import TYPES from '@/modules/shared/types';

// Domain
import { DistributeUnassignedBalanceRepository } from '@/modules/flagship/investor-goal/distribute-unassigned-balance/domain/repositories/distribute-unassigned-balance-repository';
import { DistributeUnassignedBalanceEntity } from '@/modules/flagship/investor-goal/distribute-unassigned-balance/domain/entities/distribute-unassigned-balance-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class DistributeUnassignedBalanceHttpRepository implements
  DistributeUnassignedBalanceRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/distribute-unassigned-balance/`;

  distribute(distribute_unassigned_balance_entity: DistributeUnassignedBalanceEntity):
    Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', distribute_unassigned_balance_entity)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
